// extracted by mini-css-extract-plugin
module.exports = {"AgreementCard_container":"AgreementCard_AgreementCard_container__J9jVH"};